export default __webpack_public_path__ + "static/media/GU.03c3c2af.ico";